// src/pages/VideosGallery.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import VidGalleryContent from './PageComponent/VidGalleryContent';

function VideosGallery() {
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Videos Gallery | Callistus Blinds</title>
        <meta
          name="description"
          content="Explore our video gallery to see Callistus Blinds products and operating systems in action. Dive in and find inspiration today!"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/videos-gallery/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Videos Gallery" />
        <meta
          property="og:description"
          content="Explore our video gallery to see Callistus Blinds products and operating systems in action. Dive in and find inspiration today!"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/videos-gallery/`} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <div>
        <Navbar />
        <NotificationBar />
        <VidGalleryContent />
        <Footer />
      </div>
    </>
  );
}

export default VideosGallery;